import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { IssuePinItem } from "@ServerTypes/issues/issues.schema";

export type { IssuePinItem };

type IssuesPinDataState = Record<string, IssuePinItem>;

const issuesPinDataSlice = createSlice({
  name: "issuesPinData",
  initialState: {} as IssuesPinDataState,
  reducers: {
    setIssuesPinData: (
      _state: IssuesPinDataState,
      action: PayloadAction<IssuePinItem[] | null | undefined | unknown>,
    ) =>
      (((action.payload as IssuePinItem[]) ?? []) as IssuePinItem[]).reduce(
        (prev: IssuesPinDataState, curr: IssuePinItem) => {
          if (curr && curr.id) {
            return { ...prev, [curr.id]: curr };
          }
          return prev;
        },
        {},
      ),
    mergeIssuesPinData: (state: IssuesPinDataState, action: PayloadAction<IssuePinItem>) => {
      state[action.payload.id] = { ...action.payload };
    },
    deleteIssuesPinData: (state: IssuesPinDataState, action: PayloadAction<string[]>) => {
      action.payload.forEach((issue: string) => {
        delete state[issue];
      });
    },
  },
});

export const { setIssuesPinData, mergeIssuesPinData, deleteIssuesPinData } = issuesPinDataSlice.actions;
export default issuesPinDataSlice.reducer;
